import { KommissionResult } from '@/types/service-response'

export class Commission {
  public constructor (
    readonly id: number,
    readonly kommissionNummer: string,
    readonly bezeichnung: string,
    readonly start: string,
    readonly end: string,
    readonly status: string,
    readonly aSBAdresse: string | null,
    readonly adressID: number,
    readonly adresse: string,
    readonly sachbearbeiterID : number,
    readonly sachbearbeiterName: string,
    readonly sachbearbeiterVorname: string,
    readonly fullName: string,
    readonly fach: string,
    readonly bemerkungen: string,
    readonly genAdresse: string,
    readonly art: string | null,
    readonly artBezeichnung: string,
  ) {}

  static createFromResponse (item: KommissionResult): Commission {
    return new Commission(
      item.ID,
      item.KommissionNummer ? item.KommissionNummer : '',
      item.Bezeichnung ? item.Bezeichnung : '',
      item.Start ? item.Start : '',
      item.Termin ? item.Termin : '',
      item.Status ? item.Status : '',
      item.ASBAdresse,
      item.AdressID,
      item.Adresse ? item.Adresse : '',
      item.SachbearbeiterID,
      item.SachbearbeiterName ? item.SachbearbeiterName : '',
      item.SachbearbeiterVorname ? item.SachbearbeiterVorname : '',
      item.SachbearbeiterName && item.SachbearbeiterVorname ? `${item.SachbearbeiterVorname} ${item.SachbearbeiterName}` : '',
      item.Fach ? item.Fach : '',
      item.Bemerkungen ? item.Bemerkungen : '',
      item.GenAdresse ? item.GenAdresse : '',
      item.Art ? item.Art.toString() : null,
      item.ArtBezeichnung ? item.ArtBezeichnung : '',
    )
  }

  static createListFromResponse (responseData: KommissionResult[]): Array<Commission> {
    return responseData.map((item: KommissionResult ) => {
      return new Commission(
        item.ID,
        item.KommissionNummer ? item.KommissionNummer : '',
        item.Bezeichnung ? item.Bezeichnung : '',
        item.Start ? item.Start : '',
        item.Termin ? item.Termin : '',
        item.Status ? item.Status : '',
        item.ASBAdresse,
        item.AdressID,
        item.Adresse ? item.Adresse : '',
        item.SachbearbeiterID,
        item.SachbearbeiterName ? item.SachbearbeiterName : '',
        item.SachbearbeiterVorname ? item.SachbearbeiterVorname : '',
        item.SachbearbeiterName && item.SachbearbeiterVorname ? `${item.SachbearbeiterVorname} ${item.SachbearbeiterName}` : '',
        item.Fach ? item.Fach : '',
        item.Bemerkungen ? item.Bemerkungen : '',
        item.GenAdresse ? item.GenAdresse : '',
        item.Art ? item.Art.toString() : null,
        item.ArtBezeichnung ? item.ArtBezeichnung : '',
      )
    })
  }
}
